<template>
    <v-container fill class="pa-0">
        <v-window v-model="step" v-if="currentAlAcrData && step">
            <!-- ++ GENERATE DEPRECIATION - DIALOG -->
            <v-window-item value="generateDepreciationStep">
                <v-card-text class="pa-0">
                    <v-row no-gutters class="d-flex align-center pt-4 pb-2">
                        <!-- ** depreciationType linearDepreciation  -->
                        <v-col cols="5">
                            <h3 style="height: 40px; line-height: 40px">Type</h3>
                        </v-col>

                        <v-col cols="1">
                            <h3 style="height: 40px; line-height: 40px">
                                <template class="pl-4">
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props"> $oss-help </v-icon>
                                        </template>

                                        <!-- ** tooltip text -->
                                        <h4 class="mt-2">AMORTISSEMENT LINEAIRE</h4>
                                        <p class="mb-1">Il est la norme.</p>
                                        <p class="mb-1">
                                            La charge fiscale est repartie de façon régulière sur le
                                            nombre d'années choisi.
                                        </p>
                                        <p class="mb-1">A noter :</p>
                                        <ul>
                                            <li>
                                                Le début est égal à la date de mise en service ou
                                                d'acquisition.
                                            </li>
                                            <li>
                                                La première et dernière années sont calculées aux
                                                prorata (en jours), selon la date d'achat et/ou de
                                                mise en service.
                                            </li>
                                            <li>
                                                De fait, l'amortissement s'étale sur une année de
                                                plus, même si la durée est, jour pour jour,
                                                exactement celle choisie.
                                            </li>
                                        </ul>
                                        <p class="mb-5" />
                                        <h4>AMORTISSEMENT DEGRESSIF</h4>
                                        <p class="mb-1">Par dérogation fiscale.</p>
                                        <p class="mb-1">
                                            Il fait si que la charge fiscale soit plus importante
                                            sur les premières années et qu'elle diminue
                                            progressivement.
                                        </p>
                                        <p class="mb-1">
                                            Il peut s'appliquer, par exemple à un véhicule qui perd
                                            rapidement de la valeur, dès l'achat.
                                        </p>
                                        <p class="mb-3">A noter :</p>
                                        <ul>
                                            <li>
                                                Le début est égal au premier jour du mois
                                                d'acquisition et/ou de mise en service.
                                            </li>
                                            <li>
                                                Seule la première année est calculée aux prorata (en
                                                mois entiers), selon la date d'achat et/ou de mise
                                                en service.
                                            </li>
                                            <li>
                                                De fait, la première année étant (sauf achat en
                                                janvier) incomplète et les suivantes complétes, la
                                                durée d'amortissement s'étale, certes, sur le nombre
                                                d'années choisi, mais est plus courte en nombre de
                                                mois calendriers.
                                            </li>
                                        </ul>
                                    </v-tooltip>
                                </template>
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <v-select-filled
                                type="text"
                                v-model="depreciationType"
                                :items="depreciationTypes"
                                hide-details="auto"
                                @update:model-value="changeDotAmoType()"
                                density="compact"
                            />
                        </v-col>
                    </v-row>

                    <!-- ** accountableAccount  -->
                    <v-row no-gutters class="d-flex align-center py-2">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                Compte comptable de l'écriture d'achat
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <oss-text-field-filled
                                outlined
                                dense
                                v-if="
                                    currentAlAcrData.accountableAccount &&
                                    currentAlAcrData.accountableAccount.name &&
                                    currentAlAcrData.accountableAccount.description
                                "
                                v-model="accountableAccountNameAndDescription"
                                hide-details="auto"
                                disabled
                            />
                        </v-col>
                    </v-row>

                    <v-row
                        v-if="!hideDurationAndStartDate && currentAlAcrData.type != 'N/A'"
                        no-gutters
                        class="d-flex align- py-2"
                    >
                        <!-- ** yearDuration -->
                        <v-col cols="5">
                            <h3 style="height: 40px; line-height: 40px">Durée en années</h3>
                        </v-col>

                        <v-col cols="1">
                            <h3 style="height: 40px; line-height: 40px">
                                <template
                                    v-if="
                                        currentAlAcrData.yearDuration &&
                                        (currentAlAcrData.yearDuration.defaultYearDuration ||
                                            currentAlAcrData.yearDuration.minYearDuration ||
                                            currentAlAcrData.yearDuration.maxYearDuration)
                                    "
                                >
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props"> $oss-help </v-icon>
                                        </template>

                                        <!-- ** tooltip text -->
                                        <h3
                                            v-if="
                                                currentAlAcrData.yearDuration &&
                                                currentAlAcrData.yearDuration.defaultYearDuration
                                            "
                                            style="font-weight: bold"
                                        >
                                            Durée conseillée par l'administration fiscale :
                                            {{ currentAlAcrData.yearDuration.defaultYearDuration }}
                                        </h3>

                                        <h3 v-else>
                                            Durée conseillée par l'administration fiscale :
                                            <i>pas renseignée</i>
                                        </h3>

                                        <p
                                            v-if="
                                                currentAlAcrData.yearDuration &&
                                                currentAlAcrData.yearDuration.minYearDuration &&
                                                currentAlAcrData.yearDuration.minYearDuration > 0
                                            "
                                        >
                                            Durée minimale admise :
                                            {{ currentAlAcrData.yearDuration.minYearDuration }}
                                        </p>

                                        <p v-else>Durée minimale admise : <i>pas renseignée</i></p>

                                        <!-- ** maxYearDuration ** -->
                                        <p
                                            v-if="
                                                currentAlAcrData.yearDuration &&
                                                currentAlAcrData.yearDuration.maxYearDuration &&
                                                currentAlAcrData.yearDuration.maxYearDuration > 0
                                            "
                                        >
                                            Durée maximale admise :
                                            {{ currentAlAcrData.yearDuration.maxYearDuration }}
                                        </p>

                                        <p v-else>Durée maximale admise : <i>pas renseignée</i></p>
                                    </v-tooltip>
                                </template>
                            </h3>
                        </v-col>

                        <v-col cols="6" v-if="!hideDurationAndStartDate">
                            <!-- ** minYearDuration && maxYearDuration > 0 -->
                            <oss-text-field-filled
                                v-if="depreciationType !== 'N/A'"
                                outlined
                                dense
                                hide-details="auto"
                                v-model="currentAlAcrData.selectedYearDuration"
                                :rules="[(v) => v > 0 || 'Saisir un chiffre positif']"
                            >
                                {{ currentAlAcrData.selectedYearDuration }}
                            </oss-text-field-filled>
                        </v-col>
                    </v-row>

                    <v-row
                        v-if="!hideDurationAndStartDate && currentAlAcrData.type != 'N/A'"
                        no-gutters
                        class="d-flex align-center py-2"
                    >
                        <!-- ** linearSpreadStartDate -->
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                Date de mise en service (achat :
                                {{ formatDate(currentAlAcrData.date) }})
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <!-- ** The DatePicker needs a format 'YYYY-MM-DD +++++ -->
                            <oss-date-picker-filled
                                v-if="depreciationType !== 'N/A'"
                                v-model="currentAlAcrData.linearSpreadStartDate"
                                style="flex: 1"
                                :textFieldReadOnly="false"
                                hide-details
                            >
                            </oss-date-picker-filled>
                            <!-- v-bind:minDate="currentAlAcrData.spreadMinStartDate" -->
                        </v-col>
                    </v-row>

                    <!-- <v-row no-gutters class="d-flex align-center  pb-4">
                            <v-col cols="auto" v-if="currentAlAcrData.thirdPartyCompany && currentAlAcrData.thirdPartyCompany.name">
                                <b>Fournisseur : {{currentAlAcrData.thirdPartyCompany.name}}</b>
                            </v-col>
                            <v-col v-else>
                                <b>Fournisseur : </b><i>néant</i>
                            </v-col>

                            <v-spacer></v-spacer>
                        </v-row> -->

                    <v-row no-gutters class="d-flex align-center py-2">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">Libellé immobilisation</h3>
                        </v-col>

                        <v-col cols="6">
                            <h3
                                v-if="
                                    currentAlAcrData.fixedAssetWording &&
                                    currentAlAcrData.fixedAssetWording.startsWith(
                                        'Reprise immos + amos 20',
                                    )
                                "
                            >
                                {{ currentAlAcrData.fixedAssetWording }}
                            </h3>
                            <!-- ** oss-text-field only for numbers -->
                            <v-text-field-filled
                                v-else
                                outlined
                                v-model="currentAlAcrData.fixedAssetWording"
                                type="text"
                                hide-details="auto"
                                density="compact"
                            >
                            </v-text-field-filled>
                            <!-- @update:model-value="next" -->
                        </v-col>
                    </v-row>

                    <!-- ++ not null currentAlAcrData.globalVatAmountSigned -->
                    <!-- ++ && differents total HT and fixedAsset HT -->
                    <template
                        v-if="
                            currentAlAcrData.globalNetAmountSigned &&
                            currentAlAcrData.globalNetAmountSigned !=
                                currentAlAcrData.amountSigned &&
                            currentAlAcrData.globalVatAmountSigned
                        "
                    >
                        <v-divider class="mt-6" />

                        <v-row no-gutters class="d-flex align-center pt-2 pb-0">
                            <v-col cols="12">
                                <h3 style="height: 40px; line-height: 40px">
                                    Total HT de la facture différent du montant de l'immobilisation
                                    : vérifier et corrigez le montant de la TVA
                                </h3>
                            </v-col>
                        </v-row>

                        <v-row no-gutters class="d-flex align-center py-2">
                            <v-col cols="6"> Totaux de la facture : </v-col>

                            <v-col
                                cols="3"
                                v-if="currentAlAcrData.globalNetAmountSigned !== 0"
                                class="pr-1"
                            >
                                <oss-text-field-filled
                                    outlined
                                    dense
                                    label="HT total"
                                    disabled
                                    hide-details="auto"
                                    v-model="currentAlAcrData.globalNetAmountSigned"
                                >
                                </oss-text-field-filled>
                            </v-col>
                            <v-col
                                cols="3"
                                v-if="currentAlAcrData.globalVatAmountSigned !== 0"
                                class="pl-1"
                            >
                                <oss-text-field-filled
                                    outlined
                                    dense
                                    label="TVA totale"
                                    disabled
                                    hide-details="auto"
                                    v-model="currentAlAcrData.globalVatAmountSigned"
                                >
                                </oss-text-field-filled>
                            </v-col>
                        </v-row>

                        <v-row no-gutters class="d-flex align-center py-2">
                            <v-col cols="6" v-if="currentAlAcrData.globalNetAmountSigned !== 0">
                                Dont cette immobilisation
                                <v-btn-icon
                                    icon="$remove_red_eye"
                                    @click="
                                        openObject(
                                            currentAlAcrData.documentId,
                                            currentAlAcrData.objectType,
                                        )
                                    "
                                    size="x-small"
                                />
                            </v-col>

                            <v-col cols="3" v-if="currentAlAcrData.amountSigned !== 0" class="pr-1">
                                <oss-text-field-filled
                                    outlined
                                    dense
                                    hide-details="auto"
                                    label="Prix d'achat HT"
                                    disabled
                                    v-model="currentAlAcrData.amountSigned"
                                >
                                </oss-text-field-filled>
                            </v-col>

                            <v-col cols="3"> </v-col>
                        </v-row>

                        <v-row no-gutters class="d-flex align-center pt-2 pb-4">
                            <v-col cols="6" v-if="currentAlAcrData.netAmountOriginalValue !== 0">
                            </v-col>

                            <v-col
                                cols="3"
                                v-if="currentAlAcrData.netAmountOriginalValue !== 0"
                                class="pr-1"
                            >
                                <oss-text-field-filled
                                    hide-details="auto"
                                    label="Base amortissable HT"
                                    v-model="currentAlAcrData.depreciableAmountSigned"
                                    :rules="minMaxRules(currentAlAcrData.netAmountOriginalValue)"
                                >
                                </oss-text-field-filled>
                            </v-col>

                            <v-col cols="3" class="pl-1">
                                <oss-text-field-filled
                                    v-model="currentAlAcrData.alVatAmountSigned"
                                    :rules="minMaxRules(currentAlAcrData.globalVatAmountSigned)"
                                    hint="Définir la TVA à reporter dans le tableau d'immos"
                                    hide-details="auto"
                                    label="TVA déd. (au prorata du prix total)"
                                >
                                </oss-text-field-filled>
                            </v-col>
                        </v-row>
                    </template>

                    <!-- ++ sames total HT and fixedAsset HT -->
                    <template v-else>
                        <!-- ** Purchase amount -->
                        <v-row no-gutters class="d-flex align-center py-2">
                            <v-col cols="6">
                                <h3 style="height: 40px; line-height: 40px">
                                    Valeur d'achat HT de l'immobilisation
                                </h3>
                            </v-col>

                            <v-col cols="6">
                                <oss-text-field-filled
                                    content-class="mt-3 v-text-field oss-input"
                                    hide-details="auto"
                                    readonly
                                    disabled
                                    v-model="currentAlAcrData.amountSigned"
                                >
                                </oss-text-field-filled>
                            </v-col>
                        </v-row>

                        <!-- ** Depreciation base amount -->
                        <v-row
                            no-gutters
                            class="d-flex align-center py-2"
                            v-if="!hideDurationAndStartDate && currentAlAcrData.type != 'N/A'"
                        >
                            <v-col cols="6">
                                <h3 style="height: 40px; line-height: 40px">
                                    Base amortissable HT (si différente)
                                </h3>
                            </v-col>

                            <v-col cols="6">
                                <oss-text-field-filled
                                    content-class="mt-3 v-text-field oss-input"
                                    hide-details="auto"
                                    v-model="currentAlAcrData.depreciableAmountSigned"
                                    :rules="[
                                        (v) => v > 0 || '> 0',
                                        (v) =>
                                            v <= currentAlAcrData.amountSigned ||
                                            `> à la valeur d'achat`,
                                    ]"
                                >
                                </oss-text-field-filled>
                            </v-col>
                        </v-row>

                        <!-- ** VAT -->
                        <v-row
                            no-gutters
                            class="d-flex align-center pb-4"
                            v-if="!hideDurationAndStartDate"
                        >
                            <v-col cols="6">
                                <h3 style="height: 40px; line-height: 40px">TVA</h3>
                            </v-col>

                            <v-col cols="6" v-if="currentAlAcrData.alVatAmountSigned">
                                <oss-text-field-filled
                                    content-class="mt-3 v-text-field oss-input"
                                    hide-details="auto"
                                    v-model="currentAlAcrData.alVatAmountSigned"
                                >
                                </oss-text-field-filled>
                            </v-col>

                            <v-col v-else>
                                <h3 style="height: 40px; line-height: 40px">Pas de TVA</h3>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>

                <v-divider />

                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                    <v-btn
                        rounded
                        class="ma-2"
                        @click="$emit('quitDepreciationTableDialog')"
                        :color="'secondary'"
                    >
                        Annuler
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        :disabled="disabledNextBtn(currentAlAcrData)"
                        rounded
                        class="ma-2"
                        @click="generateLocalSpreadFromServices(currentAlAcrData)"
                        :color="'primary'"
                        data-cy="CheckFixedAssetsDepreciationTable-nextCreation"
                    >
                        Suivant
                    </v-btn>
                    <!-- :disabled="disabledNextBtn(currentAlAcrData)" -->
                </v-card-actions>
            </v-window-item>

            <!-- ++ generate outflow - dialog -->
            <v-window-item value="outflowStep">
                <v-card-text class="py-0">
                    <!-- ** outflowDate -->
                    <v-row no-gutters class="d-flex align-center py-4">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                Date de sortie d'immo (mise en service :
                                {{ formatDate(currentAlAcrData.linearSpreadStartDate) }})
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <!-- ** The DatePicker needs a format 'YYYY-MM-DD +++++ -->
                            <oss-date-picker-filled
                                v-model="currentAlAcrData.outflowDate"
                                style="flex: 1"
                                :textFieldReadOnly="false"
                                :hint="`Première date comptable ouverte : ${formatDate(
                                    outflowMinDate,
                                )}`"
                                :minDate="outflowMinDate"
                                data-cy="CheckFixedAssetsDepreciationTable-dateSortie"
                            >
                            </oss-date-picker-filled>
                            <!-- v-bind:minDate="currentAlAcrData.spreadMinStartDate" -->
                        </v-col>
                    </v-row>

                    <!-- ** sellAmount -->
                    <v-row no-gutters class="d-flex align-center pb-4">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                Prix de cession (base amortissable :
                                {{
                                    newCommonFormatCurrency(
                                        currentAlAcrData.depreciableAmountSigned,
                                        undefined,
                                    )
                                }})
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <!-- ** minYearDuration && maxYearDuration > 0 -->
                            <oss-text-field-filled
                                content-class="mt-3 v-text-field oss-input"
                                v-model="currentAlAcrData.sellAmount"
                                :rules="[(v) => {
                                    const num = parseFloat((v + '').replace(',', '.'));
                                    return !isNaN(num) && num >= 0 || 'Valeur négative';
                                    }]"
                                hide-details="auto"
                            >
                            </oss-text-field-filled>
                            <!-- hint="Choisir entre val min et max" -->
                        </v-col>
                    </v-row>

                    <!-- ** sellVatRate -->
                    <v-row v-if="showOutflowVAT" no-gutters class="d-flex align-center pb-4">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">Taux de TVA</h3>
                        </v-col>

                        <v-col cols="6">
                            <!-- v-if="subjectToVAT"  -->
                            <!-- ** minYearDuration && maxYearDuration > 0 -->
                            <v-select-filled
                                :items="vatList"
                                v-model="currentAlAcrData.sellVatRate"
                                item-value="value"
                                :item-title="(item) => item.text"
                                regular
                                :hide-details="true"
                                outlined
                                density="compact"
                            >
                            </v-select-filled>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                    <v-btn
                        rounded
                        class="ma-2"
                        @click="$emit('quitDepreciationTableDialog')"
                        :color="'secondary'"
                    >
                        Annuler
                    </v-btn>

                    <v-spacer />

                    <v-btn
                        :disabled="disabledOutflowNextBtn(currentAlAcrData)"
                        rounded
                        class="ma-2"
                        color="primary"
                        data-cy="CheckFixedAssetsDepreciationTable-nextSortie"
                        @click="
                            step = 'tableStep';
                            generateOutflowLocalSpread(currentAlAcrData);
                        "
                    >
                        Suivant
                    </v-btn>
                </v-card-actions>
            </v-window-item>

            <!-- ++ GENERATE DEPRECIATION - DIALOG -->
            <!-- +++++ step tableStep - Depreciation table -->
            <v-window-item value="tableStep" class="justify-space-around">
                <v-card-text class="pa-0">
                    <template
                        v-if="
                            !onlyShowTable &&
                            !currentAlAcrData.outflowDate &&
                            currentAlAcrData.type &&
                            currentAlAcrData.type !== 'N/A'
                        "
                    >
                        <h3 style="color: #e1be7a" class="pb-0" v-if="firstUnclosedPeriod">
                            PREALABLE : toutes les périodes clôturées doivent être renseignées dans
                            "Mon dossier - Exercices"
                        </h3>
                        <h3 style="color: #e1be7a" class="pb-0">
                            Le tableau est construit en totalité
                        </h3>
                        <h3 style="color: #e1be7a" class="pb-0">
                            Les écritures de dotation aux amortissements seront générées :
                        </h3>
                        <h3
                            style="color: #e1be7a"
                            class="pb-0"
                            v-if="
                                firstUnclosedPeriod &&
                                firstUnclosedPeriod.id &&
                                accountingPeriod.id !== firstUnclosedPeriod.id
                            "
                        >
                            - seulement en partant du {{ formatDate(firstUnclosedPeriod.start) }},
                            les périodes précédantes étant clôturées.
                        </h3>
                        <h3 style="color: #e1be7a" class="pb-4">
                            - mensuellement, pour tous les exercices restant à courir.
                        </h3>
                    </template>

                    <template
                        v-if="
                            currentAlAcrData.outflowDate &&
                            currentAlAcrData.depreciationTable &&
                            currentAlAcrData.depreciationTable.length
                        "
                    >
                        <h3 style="color: #e1be7a" class="pb-0">
                            Les dotations aux amortissements postérieures à la date de sortie sont
                            supprimées.
                        </h3>

                        <h3 style="color: #e1be7a" class="pb-0">
                            En cas de sortie en milieu de mois, une écriture au prorata est générée.
                        </h3>
                    </template>

                    <template v-if="currentAlAcrData.outflowDate">
                        <h3 style="color: #e1be7a" class="pb-0">
                            L'écriture de sortie d'immo est générée, avec la reprise d'amortissement
                            linéaire + dérogatoire.
                        </h3>

                        <h3 style="color: #e1be7a" class="pb-4">
                            L'écriture de cession d'immo n'est pas générée : risque de doublon avec
                            la facture de vente.
                        </h3>
                    </template>

                    <v-row no-gutters class="pb-2">
                        <v-col cols="auto" v-if="accountableAccountNameAndDescription">
                            c/{{ accountableAccountNameAndDescription }}
                        </v-col>
                    </v-row>

                    <v-row no-gutters class="py-2">
                        <v-col cols="3" v-if="currentAlAcrData.amountSigned">
                            Valeur du bien H.T. :
                            {{
                                newCommonFormatCurrency(
                                    Math.abs(currentAlAcrData.amountSigned),
                                    undefined,
                                )
                            }}
                        </v-col>

                        <v-col v-if="currentAlAcrData != 'N/A'" cols="2" />

                        <v-col
                            cols="3"
                            v-else-if="
                                currentAlAcrData.depreciableAmountSigned &&
                                !hideDurationAndStartDate &&
                                currentAlAcrData != 'N/A'
                            "
                        >
                            Base amortissable H.T. :
                            {{
                                newCommonFormatCurrency(
                                    Math.abs(currentAlAcrData.depreciableAmountSigned),
                                    undefined,
                                )
                            }}
                        </v-col>

                        <v-col cols="3" v-else />

                        <v-col cols="3" v-if="currentAlAcrData.date">
                            Date d'acquisition : {{ formatDate(currentAlAcrData.date) }}
                        </v-col>

                        <v-col
                            cols="3"
                            v-if="
                                currentAlAcrData.linearSpreadStartDate && !hideDurationAndStartDate
                            "
                        >
                            Date de mise en service :
                            {{ formatDate(currentAlAcrData.linearSpreadStartDate) }}
                        </v-col>
                    </v-row>

                    <v-row no-gutters class="pb-2">
                        <v-col cols="3" v-if="currentAlAcrData.selectedYearDuration">
                            Durée : {{ currentAlAcrData.selectedYearDuration }} ans
                        </v-col>

                        <v-col cols="3" v-if="currentAlAcrData.selectedYearDuration">
                            Type : L {{ mathFix(100 / currentAlAcrData.selectedYearDuration) }} %

                            <span v-if="currentAlAcrData.rateDeclining">
                                - D {{ mathFix(currentAlAcrData.rateDeclining) }} %
                            </span>
                        </v-col>

                        <v-col v-else cols="3" />

                        <v-col
                            cols="3"
                            v-if="
                                currentAlAcrData.linearSpreadStartDate &&
                                currentAlAcrData.linearSpreadEndDate
                            "
                        >
                            L du {{ formatDate(currentAlAcrData.linearSpreadStartDate) }} au
                            {{ formatDate(currentAlAcrData.linearSpreadEndDate) }}
                        </v-col>

                        <!-- ** declining dates -->
                        <v-col
                            cols="3"
                            v-if="
                                currentAlAcrData.decliningSpreadStartDate &&
                                currentAlAcrData.decliningSpreadEndDate
                            "
                        >
                            D du {{ formatDate(currentAlAcrData.decliningSpreadStartDate) }} au
                            {{ formatDate(currentAlAcrData.decliningSpreadEndDate) }}
                        </v-col>
                    </v-row>

                    <v-row
                        no-gutters
                        class="pb-2"
                        v-if="
                            currentAlAcrData.type != 'N/A' &&
                            companyFirstPeriod &&
                            companyFirstPeriod.start &&
                            companyFirstPeriod.end &&
                            !hideDurationAndStartDate
                        "
                    >
                        <v-col>
                            Premier exercice : du {{ formatDate(companyFirstPeriod.start) }} au
                            {{ formatDate(companyFirstPeriod.end) }}
                        </v-col>
                    </v-row>

                    <!-- <v-divider class="py-2"></v-divider> -->

                    <!-- ++ OUTFLOW -->
                    <v-row no-gutters v-if="currentAlAcrData.outflowDate">
                        <v-col cols="3" v-if="currentAlAcrData.sellAmount">
                            Sortie : {{ formatDate(currentAlAcrData.outflowDate) }} - Prix cession :
                            {{ newCommonFormatCurrency(currentAlAcrData.sellAmount, undefined) }}
                        </v-col>

                        <v-col v-else class="pb-2">
                            Sortie : {{ formatDate(currentAlAcrData.outflowDate) }} - Mise au rebut
                        </v-col>

                        <v-col cols="3" v-if="currentAlAcrData.moreOrLessValue > 0">
                            Moins-value :
                            {{
                                newCommonFormatCurrency(currentAlAcrData.moreOrLessValue, undefined)
                            }}
                        </v-col>
                        <v-col v-else-if="currentAlAcrData.moreOrLessValue < 0" class="pb-2">
                            Plus-value :
                            {{
                                newCommonFormatCurrency(
                                    Math.abs(currentAlAcrData.moreOrLessValue),
                                    undefined,
                                )
                            }}
                        </v-col>
                        <v-col v-else class="pb-2"> +/- value : - </v-col>

                        <v-col cols="3" v-if="reversal28">
                            Reprise amo L : {{ newCommonFormatCurrency(-reversal28, undefined) }}
                        </v-col>

                        <v-col cols="3" v-if="reversal145">
                            Reprise amo dérog :
                            {{ newCommonFormatCurrency(-reversal145, undefined) }}
                        </v-col>
                    </v-row>

                    <!-- ******* TABLE DEPRECIATION ********* -->
                    <h2
                        v-if="currentAlAcrData.type && currentAlAcrData.type === 'N/A'"
                        class="pt-4 mb-2"
                    >
                        Non amortissable
                    </h2>

                    <h2 v-else-if="currentAlAcrData.linearDepreciation" class="pt-4 mb-2">
                        Tableau d'amortissement linéaire
                    </h2>
                    <h2 v-else class="pt-4 mb-2">Tableau d'amortissement dégressif</h2>

                    <v-data-table
                        v-if="
                            currentAlAcrData.depreciationTable &&
                            currentAlAcrData.depreciationTable.length
                        "
                        :headers="depreciationHeaders"
                        :items="currentAlAcrData.depreciationTable"
                        :loading="loading"
                        class="table"
                        style="border: 1px #ededed solid"
                        :items-per-page="-1"
                        fixed-header
                        :height="dataTableHeight"
                    >
                        <template #no-data>Pas d'amortissements</template>

                        <template v-slot:item="props">
                            <tr>
                                <!-- ** resumePeriodEnd -->
                                <td
                                    v-if="props.item.resumePeriodEnd"
                                    class="text-center"
                                    style="font-weight: bold; border-right: 1px solid #dddddd"
                                >
                                    {{ formatDate(props.item.resumePeriodEnd) }}
                                </td>
                                <td v-else />

                                <!-- ** linearNetBookValue0101 -->
                                <td class="text-right">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.linearNetBookValue0101,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** linearAccumulatedDepreciationStart -->
                                <td class="text-right">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.linearAccumulatedDepreciationStart,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** linearYearDepreciation -->
                                <td class="text-right" style="font-weight: bold">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.linearYearDepreciation,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** linearAccumulatedDepreciation -->
                                <td class="text-right">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.linearAccumulatedDepreciation,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** linearNetBookValue3112 -->
                                <td class="text-right" style="border-right: 1px solid #dddddd">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.linearNetBookValue3112,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** decliningNetBookValue0101 -->
                                <td
                                    class="text-right"
                                    v-if="
                                        currentAlAcrData.type === 'Dégressif' ||
                                        currentAlAcrData.type === 'D'
                                    "
                                >
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.decliningNetBookValue0101,
                                            undefined,
                                        )
                                    }}
                                </td>
                                <td v-else class="text-right">-</td>

                                <!-- ** decliningAccumulatedDepreciationStart -->
                                <td class="text-right" style="font-weight: bold">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.decliningAccumulatedDepreciationStart,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** decliningYearDepreciation -->
                                <td class="text-right" style="font-weight: bold">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.decliningYearDepreciation,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** decliningAccumulatedDepreciation -->
                                <td class="text-right">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.decliningAccumulatedDepreciation,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** decliningNetBookValue3112 -->
                                <td class="text-right" style="border-right: 1px solid #dddddd">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.decliningNetBookValue3112,
                                            undefined,
                                        )
                                    }}
                                </td>

                                <!-- ** derogationYearDepreciation -->
                                <td class="text-right" style="font-weight: bold">
                                    {{
                                        newCommonFormatCurrency(
                                            props.item.derogationYearDepreciation,
                                            undefined,
                                        )
                                    }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <!-- // ////////////////////////////// -->
                <!-- // // TODO to decomment -->
                <!-- // // but btn or switch show hide -->
                <!-- // // else, btn validate not in dialog -->
                <!-- <GetEmptyDocumentsTable
                        v-if="outflowDocumentsALs && outflowDocumentsALs.length"
                        :documentAlsCreate="outflowDocumentsALs"
                    ></GetEmptyDocumentsTable> -->

                <v-divider />

                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                    <v-btn
                        v-if="!onlyShowTable && generateDepreciation"
                        rounded
                        class="ma-2"
                        @click="step = 'generateDepreciationStep'"
                        :color="'secondary'"
                    >
                        Retour
                    </v-btn>

                    <v-btn
                        v-else-if="!onlyShowTable"
                        rounded
                        class="ma-2"
                        @click="step = 'outflowStep'"
                        :color="'secondary'"
                    >
                        Retour
                    </v-btn>

                    <v-spacer />

                    <v-btn v-if="onlyShowTable" @click="$emit('quitDepreciationTableDialog')">
                        Fermer
                    </v-btn>

                    <v-btn
                        v-else-if="generateDepreciation"
                        @click="validateDepreciation()"
                        :color="'primary'"
                        data-cy="CheckFixedAssetsDepreciationTable-validCreation"
                    >
                        Générer
                    </v-btn>

                    <v-btn
                        v-else
                        rounded
                        class="ma-2"
                        @click="validateFixedAssetOutflow()"
                        :color="'primary'"
                        data-cy="CheckFixedAssetsDepreciationTable-validSortie"
                    >
                        Générer
                    </v-btn>
                </v-card-actions>
            </v-window-item>

            <!-- ++ GENERATE AUDITCHECKRESULT - on date in closed period - ONLY TYPE N/A is allowed - DIALOG -->
            <!-- +++++ step setTypeNaOnClosedPeriod -->
            <v-window-item value="setTypeNaOnClosedPeriod">
                <v-card-text class="py-0">
                    <h2 class="py-2 yellow_custom--text">
                        La "Reprise d'immobilisations et amortissements sur exercices antérieurs" a
                        déjà été effectuée,
                    </h2>

                    <h3 class="pb-2 yellow_custom--text">
                        mais cette immobilisation, <u>incorporelle où financière</u>, placée dans
                        une <u>période clôturée</u>, n'a pas été initialisée.
                    </h3>

                    <h3 class="pb-2 yellow_custom--text">
                        Les seules actions <u>requises</u> et <u>permises</u>, afin de ne pas
                        modifier les balances et les grand-livres des périodes clôturées, sont
                    </h3>
                    <h3 class="pl-4 pb-2 yellow_custom--text">
                        - la définir en tant que non amortissable (N/A)
                    </h3>
                    <h3 class="pl-4 pb-2 yellow_custom--text">
                        - changer le libellé (si pas généré par la reprise)
                    </h3>
                    <h3 class="pl-4 pb-8 yellow_custom--text">
                        - éventuellement, modifier le montant de la TVA afférente
                    </h3>

                    <v-row no-gutters>
                        <v-col cols="auto" v-if="accountableAccountNameAndDescription">
                            <h3 style="height: 40px; line-height: 40px">
                                c/{{ accountableAccountNameAndDescription }}
                            </h3>
                        </v-col>
                    </v-row>

                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">Libellé immobilisation</h3>
                        </v-col>

                        <v-col cols="6">
                            <h3
                                v-if="
                                    currentAlAcrData.fixedAssetWording &&
                                    currentAlAcrData.fixedAssetWording.startsWith(
                                        'Reprise immos + amos 20',
                                    )
                                "
                            >
                                {{ currentAlAcrData.fixedAssetWording }}
                            </h3>
                            <!-- ** oss-text-field only for numbers -->
                            <v-text-field-filled
                                v-else
                                outlined
                                v-model="currentAlAcrData.fixedAssetWording"
                                type="text"
                                hide-details="auto"
                                density="compact"
                            >
                            </v-text-field-filled>
                        </v-col>
                    </v-row>

                    <!-- ++ sames total HT and fixedAsset HT -->

                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                Valeur d'achat HT de l'immobilisation
                            </h3>
                        </v-col>

                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">
                                {{ currentAlAcrData.amountSigned }}
                            </h3>
                        </v-col> </v-row
                    ><v-row
                        no-gutters
                        class="d-flex align-center pb-4"
                        v-if="!hideDurationAndStartDate"
                    >
                        <v-col cols="6">
                            <h3 style="height: 40px; line-height: 40px">TVA</h3>
                        </v-col>

                        <v-col cols="6" v-if="currentAlAcrData.alVatAmountSigned">
                            <oss-text-field-filled
                                content-class="mt-3 v-text-field oss-input"
                                hide-details="auto"
                                v-model="currentAlAcrData.alVatAmountSigned"
                            >
                            </oss-text-field-filled>
                        </v-col>

                        <v-col v-else>
                            <h3 style="height: 40px; line-height: 40px">Pas de TVA</h3>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                    <v-btn
                        rounded
                        class="ma-2"
                        @click="$emit('quitDepreciationTableDialog')"
                        :color="'secondary'"
                    >
                        Annuler
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        class="ma-2"
                        @click="
                            currentAlAcrData.type = 'N/A';
                            generateLocalSpreadFromServices(currentAlAcrData);
                        "
                        :color="'primary'"
                        data-cy="CheckFixedAssetsDepreciationTable-nextCreation"
                    >
                        Suivant
                    </v-btn>
                    <!-- :disabled="disabledNextBtn(currentAlAcrData)" -->
                </v-card-actions>
            </v-window-item>
        </v-window></v-container
    >
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
import { sumBy, isEmpty, cloneDeep } from "lodash";

import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { CheckBase } from "./CheckBase";
// import CheckFixedAssetsToDepreciate from "./CheckFixedAssetsToDepreciate.vue";

import { getEmptyDocument } from "../../services/documentServices";
import {
    getLastAccountingClosing,
    getAccountingClosingDate,
} from "../../services/accountingPeriods";
// import { vatList, generateLocalSpread, createOrDeleteFixedAssetReconciliations } from "../../services/audit/AuditServices"
import {
    generateLocalSpread,
    createOrDeleteFixedAssetReconciliations,
    formatDatePicker,
    generateDecliningDepreciationTable,
} from "../../services/audit/AuditServices";
import GetEmptyDocumentsTable from "./GetEmptyDocumentsTable.vue";
import { decliningBalanceFactor } from "../../../../backend/src/common/audit/auditFunctions";

import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";
import { getAuditConnectAccountableAccount } from "../../services/audit/AuditServices";
import { getDBFormattedDate } from "../../services/dateServices";
import { vatRatesAudit } from "../../services/vatServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { AccountingClosing } from "../../../../types";

@Component({
    components: {
        GetEmptyDocumentsTable,
        // CheckFixedAssetsToDepreciate
    },
    emits: ["quitDepreciationTableDialog"],
})
export class CheckFixedAssetsDepreciationTable extends CheckBase {
    // @Prop(Boolean) readonly active!: Boolean;
    @Prop({ default: null }) parentCurrentAlAcrData: any;

    // @Prop({ default: undefined }) accountingPeriod: any
    // @Prop({ default: undefined }) inAccountingPeriod: any
    @Prop({ default: "" }) parentStep: string;
    @Prop({ default: null }) depreciationTypes: any[];
    @Prop({ default: null }) companyFirstPeriod: any;
    @Prop({ default: null }) N_1AccountingPeriod: any;
    @Prop({ default: null }) lastClosedAndFirstOpenAccountingPeriods: any;
    // @Prop({ default: undefined }) lastSituationDateYYYYMMDD: string
    // @Prop({ default: "" }) startBusinessDate: string
    // @Prop({ default: undefined }) document: any
    // @Prop({ default: "" }) documentId: string
    // @Prop({ default: undefined }) thirdPartyCompany: any;
    // @Prop({ default: 0 }) windowStep: number
    // @Prop({ default: "" }) documentAcrStatus: string;
    // @Prop({ default: undefined }) documentAccountingPeriod: any
    // @Prop({ default: "" }) acKey: string;
    @Prop({ default: false }) onlyShowTable: any;
    @Prop({ default: false }) onlyNaType: boolean;
    @Prop({ default: false }) hideDurationAndStartDate: boolean;

    search: string = "";
    loading: boolean = false;

    dialog: boolean = false;
    generateDepreciation: boolean = true;

    dotAmoType: string = "Dot. Amos - ";

    depreciationType: string = "Linéaire";
    // depreciationTypes: Array<any> = ["Linéaire", "Dégressif", "N/A"]

    // ** Needed to create only documents in open periods
    // lastClosedAndFirstOpenAccountingPeriods: any = {}
    firstUnclosedPeriod: any = {};

    // N_1AccountingPeriod: any = {}

    // show: boolean = false

    documents: Array<any> = [];

    reversal28: number = 0;
    reversal145: number = 0;

    auditCheckKey: string = "rIr4hG5NdQWyEnIXvhnYtmmm";

    outflowDocuments: Array<any> = [];
    outflowDocumentsALs: Array<any> = [];
    outflowDocsIdsToDelete: Array<any> = [];
    outflowMinDate: string = null;

    resultDocumentIdsToDelete: Array<any> = [];
    reconciliationsDeletePromises: Promise<any>[] = [];

    currentAlAcrData: any = {};
    step: string = "";

    mathFix(number) {
        return mathFix(number, 2);
    }

    formatDate(date: string) {
        const returnedDate = moment(date).format("DD/MM/YYYY");
        return returnedDate;
    }

    newCommonFormatCurrency(value, options: any = undefined) {
        return newCommonFormatCurrency(value, options);
    }

    get vatList() {
        // const vats = [
        //     { value: "20", text: '20' },
        //     { value: "10", text: '10' },
        //     { value: "08", text: '8.5' },
        //     { value: "05", text: '5.5' },
        //     { value: "02", text: '2.1' },
        // ]
        return vatRatesAudit;
    }

    get decliningBalanceFactor() {
        return decliningBalanceFactor;
    }

    // ** receiving companyId from props
    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get showOutflowVAT() {
        if (this.selectedCompany?.vatSystem?.length) {
            if ( ['Normal', 'Simplified', 'SimplifiedExercise', 'Quartely'].includes(this.selectedCompany.vatSystem))
            return true
        }
        return false;
    }

    get outflowDate() {
        if (this.currentAlAcrData.outflowDate) {
            return moment(this.currentAlAcrData.outflowDate).startOf("day").format("YYYY-MM-DD");
        }
        return null;
    }

    // get window_step() {
    //     return this.windowStep
    // }

    // ++++++++++++ depreciation table headers +++++++++
    depreciationHeaders: Array<any> = [
        {
            title: "Année",
            key: "resumePeriodEnd",
            align: "center",
            sortable: false,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
        },
        {
            title: "L - VNC début",
            key: "linearNetBookkey0101",
            align: "end",
            sortable: false,
        },
        {
            title: "L - cumul N-1",
            key: "linearAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
        },
        {
            title: "L - Dot.",
            key: "linearYearDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "L - Cumul N",
            key: "linearAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "L - VNC Fin",
            key: "linearNetBookkey3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            title: "D - VNC 01-01",
            key: "decliningNetBookkey0101",
            align: "end",
            sortable: false,
        },
        {
            title: "D - cumul N-1",
            key: "decliningAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "D - Dot.",
            key: "decliningYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "D - Cumul",
            key: "decliningAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "D - VNC 31-12",
            key: "decliningNetBookkey3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            title: "Dot. dérogatoire",
            key: "derogationYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
    ];

    @Watch("parentCurrentAlAcrData", {
        immediate: true,
        deep: true,
    })
    async onCurrentAlAcrDataChanged() {
        if (this.parentCurrentAlAcrData) {
            this.currentAlAcrData = cloneDeep(this.parentCurrentAlAcrData);
            this.getOutflowMinDate();
        }
        if (this.parentStep) {
            this.step = cloneDeep(this.parentStep);
        }
    }

    changeDotAmoType() {
        if (this.depreciationType?.length) {
            if (this.depreciationType === "N/A") {
                this.currentAlAcrData.type = "N/A";
                this.currentAlAcrData.yearDuration = 0;
                this.currentAlAcrData.rate = 0;
                this.currentAlAcrData.selectedYearDuration = 0;
            } else {
                this.currentAlAcrData.type = this.depreciationType;
                this.currentAlAcrData.linearDepreciation =
                    this.depreciationType && this.depreciationType === "Linéaire" ? true : false;
                this.currentAlAcrData.dotAmoType = this.currentAlAcrData.linearDepreciation
                    ? "Dot. Amos - L - "
                    : "Dot. Amos - D - ";
            }
        }
    }

    get accountableAccountNameAndDescription() {
        if (
            this.currentAlAcrData?.accountableAccount &&
            this.currentAlAcrData.accountableAccount.name &&
            this.currentAlAcrData.accountableAccount.description
        ) {
            return (
                this.currentAlAcrData.accountableAccount.name +
                " - " +
                this.currentAlAcrData.accountableAccount.description
            );
        }
        return null;
    }

    // **************** ICON : DOCUMENT VIEW *****************
    openObject(documentId, objectType) {
        if (objectType === "document") {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: documentId,
                },
            });
        } else if (objectType === "bankTransaction") {
            this.$router.push({
                name: "reconciliation",
                params: {
                    companyId: this.companyId,
                    bankTransactionId: documentId,
                },
            });
        } else {
            debugger; // git-ignore
        }
    }

    get currentTitle() {
        switch (this.step) {
            case "generateDepreciationStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    get currentCarryForwardCutTitle() {
        switch (this.step) {
            case "singleOrMultipleChoice":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    // // ** dialog
    disabledNextBtn(currentAlAcrData) {
        if (!isEmpty(currentAlAcrData)) {
            if (currentAlAcrData.type === "N/A") {
                return false;
            }
            if (
                currentAlAcrData.selectedYearDuration &&
                currentAlAcrData.linearSpreadStartDate &&
                moment(currentAlAcrData.linearSpreadStartDate).isValid()
            ) {
                return false;
            }
        }
        return true;
    }

    disabledOutflowNextBtn(currentAlAcrData) {
        if (currentAlAcrData.outflowDate && this.outflowMinDate) {
            const outflowDate = moment(currentAlAcrData.outflowDate).format("YYYY-MM-DD");
            if (outflowDate >= this.outflowMinDate) {
                return false;
            }
        }
        return true;
    }

    // ++ DEPRECIATIONS - GENERATE
    async generateLocalSpreadFromServices(currentData) {
        this.loading = true;
        this.documents = [];

        const fromCutPrevious = false;

        let lastSituationDateYYYYMMDD;
        if (this?.$store?.state?.selected_company?.company?.id) {
            const lastAccountingClosing: AccountingClosing = await getLastAccountingClosing(
                this.$apollo,
                this.$store.state.selected_company.company.id,
            );
            if (lastAccountingClosing) {
                lastSituationDateYYYYMMDD = lastAccountingClosing.endDate;
            }
        }

        const localSpread = await generateLocalSpread(
            this.$apollo,
            this.$store,
            currentData,
            this.lastClosedAndFirstOpenAccountingPeriods,
            this.currentUser.id,
            fromCutPrevious,
            this.selectedCompany,
            this.accountingPeriod,
            lastSituationDateYYYYMMDD,
        );

        if (localSpread) {
            this.currentAlAcrData = localSpread.currentAlAcrData;
            // this.resultDocumentIdsToDelete = localSpread.resultDocumentIdsToDelete
            this.documents = localSpread.documents;
        }
        this.step = "tableStep";
        this.loading = false;
    }

    // ++ DEPRECIATIONS - VALIDATE
    async validateDepreciation() {
        this.loading = true;
        // ** validate will delete all resultDocumentIdsToDelete
        // ** either from this accountingLine or others

        // ** replace in currentAlAcrData previous documents with new ones
        // if (this.currentAlAcrData && this.currentAlAcrData.currentAlIndex > -1) {
        //     this.currentAlAcrData.alDocuments = this.documents
        // }

        const upsertVariables = {
            id:
                this.currentAlAcrData && this.currentAlAcrData.acrId
                    ? this.currentAlAcrData.acrId
                    : "",
            auditCheckKey: this.auditCheckKey,
            key:
                this.auditCheckKey +
                "_" +
                this.companyId +
                "_" +
                this.currentAlAcrData.documentId +
                "_" +
                this.currentAlAcrData.alId,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate:
                this.currentAlAcrData.thirdPartyCompany &&
                this.currentAlAcrData.thirdPartyCompany.id
                    ? { connect: { id: this.currentAlAcrData.thirdPartyCompany.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                this.currentAlAcrData.thirdPartyCompany &&
                this.currentAlAcrData.thirdPartyCompany.id
                    ? { connect: { id: this.currentAlAcrData.thirdPartyCompany.id } }
                    : undefined,
            // documentCreateConnection: !BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            documentCreateConnection: undefined,
            // documentUpdateConnection: !BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            documentUpdateConnection: undefined,
            accountingLineCreateConnection: { connect: { id: this.currentAlAcrData.alId } },
            accountingLineUpdateConnection: { connect: { id: this.currentAlAcrData.alId } },
            // bankTransactionCreateConnection: BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            bankTransactionCreateConnection: undefined,
            // bankTransactionUpdateConnection: BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            bankTransactionUpdateConnection: undefined,
            deleteDocuments: this.currentAlAcrData.resultDocumentIdsToDelete || [],
            documents: this.documents,
            data: JSON.parse(JSON.stringify(this.currentAlAcrData)) || [],
        };

        await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
            variables: upsertVariables || {},
        });

        this.loading = false;
        this.$emit("quitDepreciationTableDialog");
    }

    // ++ OUTFLOW - GENERATE
    async generateOutflowLocalSpread(currentData) {
        // ** = this.currentAlAcrData
        // ++ delete after outflowDate documents
        // ++ if partial month: generate last depreciation document
        // ++ update accountingLines in outflowAccountingLines to push in acr.data
        // ++ generate new depreciationTable
        // ++ calculate moreOrLessValue
        // ++ generate moreOrLess document

        this.loading = true;
        let currentAlAcrData = cloneDeep(currentData);

        this.outflowDocuments = [];
        let outflowDocuments = [];

        let accAccount28 = "";

        this.outflowDocumentsALs = [];
        let outflowAccountingLines: Array<any> = [];
        let outflowDocsIdsToDelete: Array<string> = [];

        let outflowLinearNetBookValue: number = 0;

        // ** "Reprise immos + amos 2022-01-01 - "
        const wordingExemple = "Reprise immos + amos 01-01-2022 - ";
        const wordingExempleLength = wordingExemple.length;
        const wordingExempleStart = "Reprise immos + amos ";

        let outflowWording: string = "";
        if (currentAlAcrData.wording.startsWith(wordingExempleStart)) {
            outflowWording = currentAlAcrData.wording.slice(wordingExempleLength);
        } else {
            outflowWording = currentAlAcrData.wording;
        }

        outflowWording += " - sortie d'immo du " + this.formatDate(this.outflowDate);

        if (currentAlAcrData.sellAmount) {
            outflowWording +=
                " - prix cession : " + newCommonFormatCurrency(currentAlAcrData.sellAmount) + "HT";

            if (currentAlAcrData?.sellVatRate?.value) {
                outflowWording += " + TVA au " + currentAlAcrData.sellVatRate.value + "%";
            }
        } else {
            outflowWording += " - mise au rebut";
        }

        if (this.outflowDate) {
            const fullDepreciated = currentAlAcrData.linearSpreadEndDate < this.outflowDate;
            if (currentAlAcrData?.type === "N/A" || fullDepreciated) {
                if (currentAlAcrData.amountSigned) {
                    if (currentAlAcrData.sellAmount) {
                        if (currentAlAcrData?.type === "N/A") {
                            currentAlAcrData.moreOrLessValue = mathFix(
                                currentAlAcrData.amountSigned - currentAlAcrData.sellAmount,
                                2,
                            );
                        } else {
                            currentAlAcrData.moreOrLessValue = mathFix(
                                -currentAlAcrData.sellAmount,
                                2,
                            );
                        }
                    }

                    let reversalAccountingLines = [
                        {
                            date: getDBFormattedDate(this.outflowDate),
                            wording: outflowWording,
                            amountSigned: currentAlAcrData.amountSigned,
                            amount: Math.abs(currentAlAcrData.amountSigned),
                            accountableAccount: await getAuditConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                currentAlAcrData.aaNameDepreciation,
                            ),
                            type: "MANAGACCOU",
                            company: { connect: { id: this.companyId } },
                            reconciliation: undefined,
                        },
                        {
                            date: getDBFormattedDate(this.outflowDate),
                            wording: outflowWording,
                            amountSigned: -currentAlAcrData.amountSigned,
                            amount: Math.abs(currentAlAcrData.amountSigned),
                            accountableAccount: await getAuditConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                currentAlAcrData.accountableAccount.name,
                            ),
                            type: "MANAGACCOU",
                            company: { connect: { id: this.companyId } },
                            reconciliation: undefined,
                        },
                    ];

                    // if (currentAlAcrData.sellAmount) {
                    //     reversalAccountingLines.push(
                    //         {
                    //             date: this.outflowDate,
                    //             wording: outflowWording,
                    //             amountSigned: -currentAlAcrData.sellAmount,
                    //             amount: Math.abs(currentAlAcrData.sellAmount),
                    //             accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "775000") ,
                    //             type: "MANAGACCOU",
                    //             company: { connect: { id: this.companyId } },
                    //             reconciliation: undefined
                    //         }
                    //     )

                    //     let globalSellAmount = currentAlAcrData.sellAmount

                    // if (currentAlAcrData.sellVatAmount && currentAlAcrData.sellVatRate?.value) {
                    //     globalSellAmount = globalSellAmount + currentAlAcrData.sellVatAmount

                    //     reversalAccountingLines.push(
                    //         {
                    //             date: this.outflowDate,
                    //             wording: outflowWording,
                    //             amountSigned: currentAlAcrData.sellVatAmount,
                    //             amount: Math.abs(currentAlAcrData.sellVatAmount),
                    //             accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "4457" + currentAlAcrData.sellVatRate.value) ,
                    //             type: "MANAGACCOU",
                    //             company: { connect: { id: this.companyId } },
                    //             reconciliation: undefined
                    //         }
                    //     )
                    // }

                    // reversalAccountingLines.push(
                    //     {
                    //         date: this.outflowDate,
                    //         wording: outflowWording,
                    //         amountSigned: globalSellAmount,
                    //         amount: Math.abs(globalSellAmount),
                    //         accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "462000") ,
                    //         type: "MANAGACCOU",
                    //         company: { connect: { id: this.companyId } },
                    //         reconciliation: undefined
                    //     }
                    // )
                    // }

                    if (reversalAccountingLines && reversalAccountingLines.length) {
                        const document: any = getEmptyDocument(
                            this.companyId,
                            outflowWording,
                            "MISCELLANEOUS_OPERATION",
                            this.outflowDate,
                            this.currentUser.id,
                            null,
                            reversalAccountingLines,
                            true, // accountingLinesLocked
                        );

                        this.outflowDocumentsALs.push(document.accountingLines.create);
                        this.outflowDocuments = [document];
                    }
                }
            } else if (currentAlAcrData.depreciationTable.length) {
                const query = await this.$apollo.query({
                    query: gql`
                        query auditCheckResult($id: ID!) {
                            auditCheckResult(where: { id: $id }) {
                                id
                                data
                                results {
                                    id
                                    date
                                    accountingLines {
                                        id
                                        date
                                        wording
                                        amount
                                        amountSigned
                                        accountableAccount {
                                            name
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        id: currentAlAcrData.acrId,
                    },
                });

                if (query?.data?.auditCheckResult?.id) {
                    currentAlAcrData.accountingLines =
                        cloneDeep(query.data.auditCheckResult.data?.accountingLines) || [];
                }

                if (currentAlAcrData.accountingLines?.length) {
                    // ++ accountingLinesToBeKept + outflowAccountingLines (for new outflowResume)
                    outflowAccountingLines = currentAlAcrData.accountingLines.filter(
                        (d) => moment(d.date).format("YYYY-MM-DD") <= this.outflowDate,
                    );
                }

                // ++ docsToDelete + outflowDocsIdsToDelete + last partial month depreciation (incrementing outflowAccountingLines)
                if (currentAlAcrData.results?.length) {
                    // ** docsToDelete + outflowDocsIdsToDelete
                    const docsToDelete: Array<any> = currentAlAcrData.results.filter(
                        (d) => moment(d.date).format("YYYY-MM-DD") > this.outflowDate,
                    );
                    outflowDocsIdsToDelete = docsToDelete?.map((dtd) => dtd.id);

                    // ** last partial month depreciation (incrementing outflowAccountingLines)
                    const days = moment(this.outflowDate).date();

                    const outflowEndOfMonth = parseInt(
                        moment(this.outflowDate).clone().endOf("month").format("DD"),
                        10,
                    );

                    const lastDocAccountingLines = [];

                    if (days && days < outflowEndOfMonth && docsToDelete?.length) {
                        if (docsToDelete?.[0]?.accountingLines?.length) {
                            for (const al of docsToDelete[0].accountingLines) {
                                const reversalAL: any = {};
                                reversalAL.amountSigned = mathFix(
                                    (al.amountSigned * days) / outflowEndOfMonth,
                                    2,
                                );
                                reversalAL.amount = Math.abs(reversalAL.amountSigned);
                                reversalAL.date = getDBFormattedDate(this.outflowDate);
                                reversalAL.wording =
                                    "Dot. Amos - " + currentAlAcrData.fixedAssetWording;
                                const aaName =
                                    al.accountableAccount?.name ||
                                    al.accountableAccount?.connect?.name;
                                // eslint-disable-next-line no-await-in-loop
                                reversalAL.accountableAccount =
                                    await getAuditConnectAccountableAccount(
                                        this.$store,
                                        this.$apollo,
                                        aaName,
                                    );
                                reversalAL.reconciliation = undefined;
                                (reversalAL.company = { connect: { id: this.companyId } }),
                                    outflowAccountingLines.push(reversalAL);

                                lastDocAccountingLines.push(reversalAL);
                            }
                        }

                        const lastDepreciation = getEmptyDocument(
                            this.companyId,
                            "Dot. Amos - " + currentAlAcrData.fixedAssetWording,
                            "MISCELLANEOUS_OPERATION",
                            this.outflowDate,
                            this.currentUser.id,
                            null,
                            lastDocAccountingLines,
                            true, // accountingLinesLocked
                        );
                        outflowDocuments.push(lastDepreciation);
                    }
                }

                // ** set accountableAccounts for reversal document
                const al28 = outflowAccountingLines.find(
                    (al) =>
                        al.accountableAccount &&
                        (al.accountableAccount?.connect?.uniqueName?.name.startsWith("28") ||
                            (al.accountableAccount.name &&
                                al.accountableAccount.name.startsWith("28"))),
                );

                if (al28) {
                    accAccount28 =
                        al28.accountableAccount.name ||
                        al28.accountableAccount.connect.uniqueName.name;
                }

                let document: any = {};

                // ++++++++++++++++++++++++++++++++++++++++++++++++++
                // +++++++++++++ DEPRECIATION TABLE *****************
                let resumeAccountingPeriod: any = {};
                const outflowResume = [];

                if (outflowAccountingLines.length) {
                    const resumeOutflowAccountingLines =
                        JSON.parse(JSON.stringify(outflowAccountingLines)) || [];

                    let resumePeriodEnd = currentAlAcrData.alFirstPeriod.end; // ** YYYY-MM-DD

                    if (
                        moment(resumePeriodEnd).isBefore(
                            moment(outflowAccountingLines[0].date).format("YYYY-MM-DD"),
                        )
                    ) {
                        resumePeriodEnd = moment(resumePeriodEnd)
                            .add(1, "years")
                            .format("YYYY-MM-DD");
                    }

                    // ** create outflowResume structure
                    outflowResume.push({
                        resumePeriodEnd: resumePeriodEnd,
                        netBookValueStart: mathFix(currentAlAcrData.netAmountOriginalValue, 2),
                        linearYearDepreciation: 0,
                        decliningYearDepreciation: 0,
                        derogationYearDepreciation: 0,
                    });

                    for (let y2 = 0; y2 < resumeOutflowAccountingLines.length; y2++) {
                        const dateAfterResume = moment(
                            moment(resumeOutflowAccountingLines[y2].date).format("YYYY-MM-DD"),
                        ).isAfter(
                            moment(
                                moment(
                                    outflowResume[outflowResume.length - 1].resumePeriodEnd,
                                ).format("YYYY-MM-DD"),
                            ),
                        );
                        if (dateAfterResume) {
                            resumePeriodEnd = moment(resumePeriodEnd)
                                .startOf("day")
                                .add(1, "years")
                                .format("YYYY-MM-DD");

                            outflowResume.push({
                                resumePeriodEnd: resumePeriodEnd,
                                linearYearDepreciation: 0,
                                decliningYearDepreciation: 0,
                                derogationYearDepreciation: 0,
                            });
                        }

                        let linearDep = 0;
                        let derogDep = 0;

                        // ** LINEAR
                        if (
                            resumeOutflowAccountingLines[y2].accountableAccount &&
                            ((resumeOutflowAccountingLines[y2].accountableAccount.name &&
                                resumeOutflowAccountingLines[y2].accountableAccount.name.startsWith(
                                    "6811",
                                )) ||
                                (resumeOutflowAccountingLines[y2].accountableAccount.connect &&
                                    resumeOutflowAccountingLines[y2].accountableAccount.connect
                                        .uniqueName.name &&
                                    resumeOutflowAccountingLines[
                                        y2
                                    ].accountableAccount.connect.uniqueName.name.startsWith(
                                        "6811",
                                    )))
                        ) {
                            linearDep = mathFix(resumeOutflowAccountingLines[y2].amountSigned, 2);

                            if (linearDep) {
                                outflowResume[outflowResume.length - 1].linearYearDepreciation +=
                                    mathFix(linearDep, 2);
                                linearDep = 0;
                            }
                        } else if (
                            // ** DEROGATION
                            resumeOutflowAccountingLines[y2].accountableAccount &&
                            ((resumeOutflowAccountingLines[y2].accountableAccount.name &&
                                (resumeOutflowAccountingLines[
                                    y2
                                ].accountableAccount.name.startsWith("68725") ||
                                    resumeOutflowAccountingLines[
                                        y2
                                    ].accountableAccount.name.startsWith("78725"))) ||
                                (resumeOutflowAccountingLines[y2].accountableAccount.connect &&
                                    resumeOutflowAccountingLines[y2].accountableAccount.connect
                                        .uniqueName.name &&
                                    (resumeOutflowAccountingLines[
                                        y2
                                    ].accountableAccount.connect.uniqueName.name.startsWith(
                                        "68725",
                                    ) ||
                                        resumeOutflowAccountingLines[
                                            y2
                                        ].accountableAccount.connect.uniqueName.name.startsWith(
                                            "78725",
                                        ))))
                        ) {
                            derogDep = mathFix(resumeOutflowAccountingLines[y2].amountSigned, 2);
                        }
                        if (derogDep) {
                            outflowResume[outflowResume.length - 1].derogationYearDepreciation +=
                                mathFix(derogDep, 2);
                            derogDep = 0;
                        }
                    }

                    for (let y = 0; y < outflowResume.length; y++) {
                        // ** linear
                        outflowResume[y].linearNetBookValue0101 = outflowResume[y - 1]
                            ? mathFix(outflowResume[y - 1].linearNetBookValue3112, 2)
                            : mathFix(currentAlAcrData.amountSigned, 2);

                        outflowResume[y].linearAccumulatedDepreciationStart =
                            outflowResume[y - 1] &&
                            outflowResume[y - 1].linearAccumulatedDepreciation
                                ? mathFix(outflowResume[y - 1].linearAccumulatedDepreciation, 2)
                                : 0;

                        outflowResume[y].linearYearDepreciation = mathFix(
                            outflowResume[y].linearYearDepreciation,
                            2,
                        );

                        outflowResume[y].linearAccumulatedDepreciation = outflowResume[y - 1]
                            ? mathFix(
                                  outflowResume[y - 1].linearAccumulatedDepreciation +
                                      outflowResume[y].linearYearDepreciation,
                                  2,
                              )
                            : mathFix(outflowResume[y].linearYearDepreciation, 2);

                        outflowResume[y].linearNetBookValue3112 = outflowResume[y - 1]
                            ? mathFix(
                                  outflowResume[y - 1].linearNetBookValue3112 -
                                      outflowResume[y].linearYearDepreciation,
                                  2,
                              )
                            : mathFix(
                                  currentAlAcrData.amountSigned -
                                      outflowResume[y].linearYearDepreciation,
                                  2,
                              );

                        if (outflowResume[y].derogationYearDepreciation) {
                            outflowResume[y] = await generateDecliningDepreciationTable(
                                outflowResume,
                                y,
                                currentAlAcrData,
                            );
                        }
                    }

                    currentAlAcrData.depreciationTable = outflowResume;

                    // +++++++++ OUTFLOW ++++++++++
                    // ++ DOCUMENTS +++++++++++++++++++++
                    // ** c/675 « Valeurs comptables des éléments d'actifs cédés »
                    // ** c/28 « Amortissements des immobilisations »
                    // **           à c/2 « Immobilisations »

                    // ** c/145 « Amortissements dérogatoires »
                    // **           à c/78725 « Reprise sur provisions règlementées – amortissements dérogatoires »

                    const AL28 = outflowAccountingLines.filter(
                        (al) =>
                            al.accountableAccount &&
                            ((al.accountableAccount.connect &&
                                al.accountableAccount.connect.uniqueName.name &&
                                al.accountableAccount.connect.uniqueName.name.startsWith("28")) ||
                                (al.accountableAccount.name &&
                                    al.accountableAccount.name.startsWith("28"))),
                    );

                    const AL145 = outflowAccountingLines.filter(
                        (al) =>
                            al.accountableAccount &&
                            ((al.accountableAccount.connect &&
                                al.accountableAccount.connect.uniqueName.name &&
                                al.accountableAccount.connect.uniqueName.name.startsWith("145")) ||
                                (al.accountableAccount.name &&
                                    al.accountableAccount.name.startsWith("145"))),
                    );

                    const reversalAccountingLines = [];

                    if (AL28 && AL28.length) {
                        this.reversal28 = mathFix(
                            AL28.reduce((a, b) => a + b.amountSigned, 0),
                            2,
                        );

                        if (this.reversal28 && accAccount28.length) {
                            reversalAccountingLines.push(
                                {
                                    date: this.outflowDate,
                                    wording: outflowWording,
                                    amountSigned: -this.reversal28,
                                    amount: Math.abs(this.reversal28),
                                    accountableAccount: await getAuditConnectAccountableAccount(
                                        this.$store,
                                        this.$apollo,
                                        accAccount28,
                                    ),
                                    type: "MANAGACCOU",
                                    company: { connect: { id: this.companyId } },
                                    reconciliation: undefined,
                                },
                                {
                                    date: this.outflowDate,
                                    wording: outflowWording,
                                    amountSigned: -currentAlAcrData.amountSigned,
                                    amount: Math.abs(currentAlAcrData.amountSigned),
                                    accountableAccount: await getAuditConnectAccountableAccount(
                                        this.$store,
                                        this.$apollo,
                                        currentAlAcrData.accountableAccount.name,
                                    ),
                                    type: "MANAGACCOU",
                                    company: { connect: { id: this.companyId } },
                                    reconciliation: undefined,
                                },
                            );

                            outflowLinearNetBookValue = mathFix(
                                currentAlAcrData.amountSigned + this.reversal28,
                                2,
                            );
                            if (outflowLinearNetBookValue) {
                                reversalAccountingLines.push({
                                    date: this.outflowDate,
                                    wording: outflowWording,
                                    amountSigned: outflowLinearNetBookValue,
                                    amount: Math.abs(outflowLinearNetBookValue),
                                    accountableAccount:
                                        currentAlAcrData.accountableAccount.name.startsWith("20")
                                            ? await getAuditConnectAccountableAccount(
                                                  this.$store,
                                                  this.$apollo,
                                                  "675100",
                                              )
                                            : await getAuditConnectAccountableAccount(
                                                  this.$store,
                                                  this.$apollo,
                                                  "675200",
                                              ),
                                    type: "MANAGACCOU",
                                    company: { connect: { id: this.companyId } },
                                    reconciliation: undefined,
                                });
                            }

                            if (AL145 && AL145.length) {
                                this.reversal145 = AL145.reduce((a, b) => a + b.amountSigned, 0);

                                if (this.reversal28 && accAccount28.length) {
                                    reversalAccountingLines.push(
                                        {
                                            date: this.outflowDate,
                                            wording: outflowWording,
                                            amountSigned: -this.reversal145,
                                            amount: Math.abs(this.reversal145),
                                            accountableAccount:
                                                await getAuditConnectAccountableAccount(
                                                    this.$store,
                                                    this.$apollo,
                                                    "145000",
                                                    undefined,
                                                    undefined,
                                                    true,
                                                ),
                                            type: "MANAGACCOU",
                                            company: { connect: { id: this.companyId } },
                                            reconciliation: undefined,
                                        },
                                        {
                                            date: this.outflowDate,
                                            wording: outflowWording,
                                            amountSigned: this.reversal145,
                                            amount: Math.abs(this.reversal145),
                                            accountableAccount:
                                                await getAuditConnectAccountableAccount(
                                                    this.$store,
                                                    this.$apollo,
                                                    "787250",
                                                ),
                                            type: "MANAGACCOU",
                                            company: { connect: { id: this.companyId } },
                                            reconciliation: undefined,
                                        },
                                    );
                                }
                            }

                            if (reversalAccountingLines && reversalAccountingLines.length) {
                                document = getEmptyDocument(
                                    this.companyId,
                                    outflowWording,
                                    "MISCELLANEOUS_OPERATION",
                                    this.outflowDate,
                                    this.currentUser.id,
                                    null,
                                    reversalAccountingLines,
                                    true, // accountingLinesLocked
                                );

                                outflowDocuments.push(document);
                            }

                            // ** c/462 « Créances sur cessions d'immobilisations » TTC,
                            // **       c/775 « Produits des cessions d'éléments d'actif » HT,
                            // **       c/4457 « TVA collectée ».

                            // if (currentAlAcrData.sellAmount) {
                            //     const sellAccountingLines = []
                            //     sellAccountingLines.push(
                            //         {
                            //             date: this.outflowDate,
                            //             wording: outflowWording,
                            //             amountSigned: -currentAlAcrData.sellAmount,
                            //             amount: Math.abs(currentAlAcrData.sellAmount),
                            //             accountableAccount: currentAlAcrData.accountableAccount.name.startsWith("20") ? await getAuditConnectAccountableAccount(this.$store, this.$apollo, "775100") : await getAuditConnectAccountableAccount(this.$store, this.$apollo, "775200"),
                            //             type: "MANAGACCOU",
                            //             company: { connect: { id: this.companyId } }
                            //         }
                            //     )

                            //     if (currentAlAcrData.sellVatRate) {
                            //         currentAlAcrData.sellVatAmount = mathFix((currentAlAcrData.sellAmount * parseInt(currentAlAcrData.sellVatRate.text, 10) / 100), 2)
                            //         sellAccountingLines.push(
                            //             {
                            //                 date: this.outflowDate,
                            //                 wording: outflowWording,
                            //                 amountSigned: -currentAlAcrData.sellVatAmount,
                            //                 amount: Math.abs(currentAlAcrData.sellVatAmount),
                            //                 accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "4457" + currentAlAcrData.sellVatRate.value) ,
                            //                 type: "MANAGACCOU",
                            //                 company: { connect: { id: this.companyId } }
                            //             },
                            //             {
                            //                 date: this.outflowDate,
                            //                 wording: outflowWording,
                            //                 amountSigned: currentAlAcrData.sellAmount + currentAlAcrData.sellVatAmount,
                            //                 amount: Math.abs(currentAlAcrData.sellAmount + currentAlAcrData.sellVatAmount),
                            //                 accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "462000") ,
                            //                 type: "MANAGACCOU",
                            //                 company: { connect: { id: this.companyId } }
                            //             },
                            //         )
                            //     } else {
                            //         sellAccountingLines.push(
                            //             {
                            //                 date: this.outflowDate,
                            //                 wording: outflowWording,
                            //                 amountSigned: currentAlAcrData.sellAmount,
                            //                 amount: Math.abs(currentAlAcrData.sellAmount),
                            //                 accountableAccount: await getAuditConnectAccountableAccount(this.$store, this.$apollo, "462000") ,
                            //                 type: "MANAGACCOU",
                            //                 company: { connect: { id: this.companyId } }
                            //             },
                            //         )
                            //     }

                            //     if (sellAccountingLines && sellAccountingLines.length) {
                            //         document = getEmptyDocument(
                            //             this.companyId,
                            //             outflowWording,
                            //             "MISCELLANEOUS_OPERATION",
                            //             this.outflowDate,
                            //             this.currentUser.id,
                            //             null,
                            //             sellAccountingLines,
                            //         )
                            //     }
                            //     outflowDocuments.push(document)
                            // }

                            currentAlAcrData.outflowLinearNetBookValue =
                                outflowLinearNetBookValue || undefined;

                            currentAlAcrData.moreOrLessValue = currentAlAcrData.sellAmount
                                ? mathFix(
                                      outflowLinearNetBookValue - currentAlAcrData.sellAmount,
                                      2,
                                  )
                                : mathFix(outflowLinearNetBookValue, 2);
                            this.outflowDocsIdsToDelete = outflowDocsIdsToDelete;
                        }
                    }
                }
                // this.outflowDocumentsALs = outflowAccountingLines
                for (const doc of outflowDocuments) {
                    this.outflowDocumentsALs.push(...doc.accountingLines.create);
                }
                // this.outflowDocumentsALs = outflowDocuments.map(doc => doc.accountingLines.create)
                this.outflowDocuments = outflowDocuments;
            }
        }
        this.currentAlAcrData = currentAlAcrData;
        this.generateDepreciation = false;
        this.step = "tableStep";
        this.loading = false;
    }

    // ++ OUTFLOW - VALIDATE
    async validateFixedAssetOutflow() {
        // ** validate will delete all resultDocumentIdsToDelete
        // ** either from this accountingLine or others

        // ** replace in currentAlAcrData previous documents with new ones
        // if (this.currentAlAcrData && this.currentAlAcrData.currentAlIndex > -1) {
        //     this.currentAlAcrData.alDocuments = this.documents
        // }

        this.loading = true;

        const upsertVariables = {
            id:
                this.currentAlAcrData && this.currentAlAcrData.acrId
                    ? this.currentAlAcrData.acrId
                    : "",
            auditCheckKey: this.auditCheckKey,
            key:
                this.auditCheckKey +
                "_" +
                this.companyId +
                "_" +
                this.currentAlAcrData.documentId +
                "_" +
                this.currentAlAcrData.alId,
            companyId: this.companyId,
            status: "UNKNOWN",
            thirdPartyCompanyCreate:
                this.currentAlAcrData.thirdPartyCompany &&
                this.currentAlAcrData.thirdPartyCompany.id
                    ? { connect: { id: this.currentAlAcrData.thirdPartyCompany.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                this.currentAlAcrData.thirdPartyCompany &&
                this.currentAlAcrData.thirdPartyCompany.id
                    ? { connect: { id: this.currentAlAcrData.thirdPartyCompany.id } }
                    : undefined,
            // documentCreateConnection: !BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            documentCreateConnection: undefined,
            // documentUpdateConnection: !BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            documentUpdateConnection: undefined,
            accountingLineCreateConnection: { connect: { id: this.currentAlAcrData.alId } },
            accountingLineUpdateConnection: { connect: { id: this.currentAlAcrData.alId } },
            // bankTransactionCreateConnection: BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            bankTransactionCreateConnection: undefined,
            // bankTransactionUpdateConnection: BT ? {connect: {id: this.currentAlAcrData.documentId}} : undefined,
            bankTransactionUpdateConnection: undefined,
            deleteDocuments: this.outflowDocsIdsToDelete || [],
            documents: this.outflowDocuments,
            data: JSON.parse(JSON.stringify(this.currentAlAcrData)) || [],
        };

        const result: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
            variables: upsertVariables,
        });

        if (result?.data?.upsertAuditCheckResult) {
            const query = await this.$apollo.query({
                query: gql`
                    query auditCheckResult($id: ID!) {
                        auditCheckResult(where: { id: $id }) {
                            id
                            data
                            results {
                                id
                                date
                                accountingLines {
                                    id
                                    date
                                    wording
                                    amountSigned
                                    accountableAccount {
                                        name
                                    }
                                }
                            }
                        }
                    }
                `,
                variables: {
                    id: this.currentAlAcrData.acrId,
                },
            });

            if (query?.data?.auditCheckResult?.id) {
                this.currentAlAcrData.results =
                    cloneDeep(query.data.auditCheckResult.results) || [];

                const promises = await createOrDeleteFixedAssetReconciliations(
                    this.$apollo,
                    this.currentAlAcrData,
                    this.currentAlAcrData.results,
                    "CREATE_RECONCILIATION",
                    this.companyId,
                );
                // 'DELETE_RECONCILIATION',
                if (promises?.promises?.length) {
                    try {
                        const promisesDone = await Promise.all(promises.promises);
                    } catch (e) {
                        console.error("Error while reconciliations:" + e);
                    }
                } else if (promises?.error) {
                    console.error(promises.error);
                }
            }
        }

        // this.removedInitialItems = [];
        // await this.refresh();

        // await this.computeCarryForward()

        // this.quitDepreciationTableDialog()

        // await Promise.all(results);

        // if (this.$apollo.queries && this.$apollo.queries.auditItems) {
        //     this.$apollo.queries.auditItems.refetch();
        // } else {
        //     // eslint-disable-next-line
        //     debugger // git-ignore
        // }

        this.loading = false;

        this.$emit("quitDepreciationTableDialog");
    }

    get dataTableHeight() {
        return "min(" + 48 * (this.currentAlAcrData.depreciationTable.length + 2) + "px, 30vh)";
    }

    minMaxRules(globalVatAmountSigned) {
        return [
            (v) =>
                parseInt(v) <= globalVatAmountSigned ||
                "Valeur maximale " + [globalVatAmountSigned] + "€",
            (v) => parseInt(v) >= 0 || "Valeur minimale >= 0",
        ];
    }

    async getOutflowMinDate() {
        const minAccountingDate = await getAccountingClosingDate(
            this.$apollo,
            this.companyId,
            this.accountingPeriod.start,
        );
        if (minAccountingDate && minAccountingDate > this.currentAlAcrData.linearSpreadStartDate) {
            this.outflowMinDate = formatDatePicker(minAccountingDate);
        } else {
            this.outflowMinDate = formatDatePicker(this.currentAlAcrData.linearSpreadStartDate);
        }
    }

    // quitDepreciationTableDialog() {
    //     this.dialog = false
    //     this.generateDepreciation = true
    //     this.documents = []
    //     this.resultDocumentIdsToDelete = []
    //     this.currentAlAcrData = {}
    //     this.onlyShowTable = false
    //     this.dotAmoType = "Dot. Amos - "
    //     this.step = ""
    //     this.$emit("quitDepreciationTableDialog")
    //     // this.selectedDocumentId = ""
    //     // this.objectType = ""
    //     // this.inAccountingPeriod = {}
    //     // this.switch1 = true
    // }
}

export default toNative(CheckFixedAssetsDepreciationTable);
</script>
